import { getDrawingData } from "../../DrawingRegisterTab/api";

export const onAddingNewDrawing = async ({
  drawing,
  selectedDrawings,
  setSelectedDrawings,
}) => {
  const res = await getDrawingData(drawing.id);
  const materials = res?.materials || [];

  if (materials?.[0]?.tagNumber) {
    const taggedMaterials = materials.map((m) => {
      const { component, size } = m.taggedMaterial;

      const description = !m.description
        ? component + " " + size
        : m.description;

      return { ...m, description };
    });

    setSelectedDrawings([
      ...selectedDrawings,
      { ...drawing, materials: taggedMaterials },
    ]);
  } else {
    setSelectedDrawings([...selectedDrawings, { ...drawing, materials }]);
  }
};
